import React from 'react'

export const PaymentSuccessful = () => {
  return (
    <div>PaymentSuccessful</div>
  )
}
